import React, {Fragment, useMemo} from 'react';
import {
  ShiftsLoader,
  TasksLoader,
  useScheduleDataContext,
} from '../../../services';
import {useSharedErrorHandler} from '../../../services/entities/utils/errorHandlers';
import {getDateRangeByFullMonthsFormatted} from '../functions';

type Props = {
  teamId: number;
  onError?: (error: Error) => void;
};

export const ScheduleLoader: React.FC<Props> = ({teamId, onError}) => {
  const sharedOnError = useSharedErrorHandler(onError);
  const context = useScheduleDataContext();
  const monthsRanges = useMemo(
    () =>
      getDateRangeByFullMonthsFormatted(
        context.dates.totalRange.fromDate,
        context.dates.totalRange.toDate,
      ),
    [context.dates.totalRange.fromDate, context.dates.totalRange.toDate],
  );

  return (
    <>
      {monthsRanges.map(month => {
        console.log('Loader range', month.startOfMonth, month.endOfMonth);
        return (
          <Fragment key={`month-${month.startOfMonth}`}>
            <ShiftsLoader
              teamId={teamId}
              fromDate={month.startOfMonth}
              toDate={month.endOfMonth}
              onError={sharedOnError}
            />
            <TasksLoader
              teamId={teamId}
              fromDate={month.startOfMonth}
              toDate={month.endOfMonth}
              onError={sharedOnError}
            />
          </Fragment>
        );
      })}
    </>
  );
};
